import { render, staticRenderFns } from "./tag_summary.vue?vue&type=template&id=6e2e1794&scoped=true"
import script from "./tag_summary.vue?vue&type=script&lang=js"
export * from "./tag_summary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e2e1794",
  null
  
)

export default component.exports